class breadCrumbsController {
}

const breadCrumbsComponentDefinition = {
    bindings: {
        backLink: '<?',
        links: '<?',
    },
    controller: breadCrumbsController,
    template: require('./breadcrumbs.component.html').trim(),
};

module.exports = {
    breadCrumbsController,
    breadCrumbsComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/breadcrumbs/breadcrumbs.component.js